import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "../../lib/api";

export default function WhatsAppFab() {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp ile İletişime Geç"
      data-testid="whatsapp-fab"
      className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-40 inline-flex items-center gap-2.5 rounded-full bg-[#25D366] px-4 py-3.5 md:px-5 md:py-4 text-white font-display font-bold text-sm uppercase tracking-wider shadow-[0_10px_30px_-5px_rgba(37,211,102,0.6)] hover:scale-105 transition-transform"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-50 blur-md -z-10 pulse-soft" />
      <MessageCircle className="h-5 w-5" />
      <span className="hidden sm:inline">WhatsApp</span>
    </a>
  );
}
